<template lang="pug">
	.license-requests-list.tb-padding(v-if="($auth.isStationOwner() && $auth.isDirector()) || $auth.isAdmin()")
		ListView.full-width(ref="listView", :searchVisible="true", initialView="table", :columnHidingEnabled="false", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="() => items", :getData="loadData", :columns="columns")
			template(v-slot:actions-template="{ data }")
				.flex-row.space.justify-end
					a.license-link.flex-row.space.dx-button.dx-button-default.align-center(v-if="data.State === 1 || data.LicenseXML", :href="getLicenseLink(data)", target="_blank")
						i.fas.fa-certificate
						span {{$tCaption('Download license')}}
					DxButton(v-if="data.State === -1", @click="() => setMappingLicenseRequestId(data.Oid)", icon="fas fa-link", :text="$tCaption('Stations list')")
					template(v-if="$auth.isAdmin() && data.State === 0")
						DxButton(type="success", :text="$tCaption('Approve & Sign')", icon="fas fa-check", @click="v => approve(data.Oid, 1)", :disabled="processingItems.indexOf(data.Oid) > -1")
						DxButton(type="danger", :text="$tCaption('Deny')", icon="fas fa-times", @click="v => approve(data.Oid, 2)", :disabled="processingItems.indexOf(data.Oid) > -1")
					template(v-if="!$auth.isAdmin() && [0,1].indexOf(data.State) > -1")
						DxButton(type="normal", :text="$tCaption('Revoke request')", icon="fas fa-times", @click="v => revoke(data.Oid)", :disabled="processingItems.indexOf(data.Oid) > -1")
			template(v-slot:request-xml-template="{ data }")
				.xml-text(@click="xmlRequestTextVisible = !xmlRequestTextVisible", :class="{ collapsed: !xmlRequestTextVisible }") {{data.RequestXML}}
			template(v-slot:state-template="{ data }")
				span.state-text(:class="[ data.State === -1 ? 'initial' : (data.State === 0 ? 'pending' : data.State === 1 ? 'approved' : 'denied') ]") {{data.StateName}}
			template(slot="left-actions")
				.flex-row.space.align-center
					.font-large {{$tCaption('My Ad Server Licenses')}}
					FileUploader(v-if="!isUploading", :dropText="$tCaption('Or drop the license file here')", ref="uploader", :text="$tCaption('Upload License File')", icon="fas fa-cloud-upload-alt", @upload="onFileUpload")
						span {{$tCaption('Please upload the license file generated by the Adthos Ad Server')}}
					Loader(v-else, :text="$tCaption('Uploading license request') + '..'")
			template(slot="right-actions")
				.flex-2(v-if="adServerDownloadLink")
					.flex-row
						a.flex-row.align-center.upper.download-ad-server-link.flex-row.space.dx-button.dx-button-normal.align-center(:href="adServerDownloadLink")
							i.fas.fa-download
							span {{$tCaption('Download AD Server')}}
		.page-add-item-button
			DxButton(icon="plus", type="default", @click="addNewRow", :disabled="isUploading")
		LicenseRequestMapping(:licenseRequestId="mappingLicenseRequestId", @close="onLicenseRequestsClose", @submit="$refs.listView.reload()")
</template>

<script>
import Data from 'app-core/Data';
import ListView from 'app-core/ListView.vue';
import DxButton from 'devextreme-vue/button';
import FileUploader from 'app-core/FileUploader.vue';
import Loader from 'app-core/Loader.vue';
import LicenseRequestMapping from './LicenseRequestMapping.vue';

export default {
	translationCategory: 'user.LicenseRequests',
	components: { ListView, DxButton, FileUploader, Loader, LicenseRequestMapping },
	data() {
		return {
			columns: [
				{ dataField: 'Date', caption: () => this.$tCaption('Date'), dataType: 'date' },
				{ dataField: 'ContactName', caption: () => this.$tCaption('Contact name') },
				{ dataField: 'StationNames', caption: () => this.$tCaption('Stations') },
				{ dataField: 'CpuId', caption: () => this.$tCaption('CPU ID'), visible: this.$auth.isAdmin() },
				{ dataField: 'RequestXML', caption: () => this.$tCaption('RequestXML'), cellTemplate: 'request-xml-template', visible: this.$auth.isAdmin() },
				{ dataField: 'StateName', caption: () => this.$tCaption('State'), cellTemplate: 'state-template' },
				{ dataField: 'ContactName', caption: ' ', name: 'actions', cellTemplate: 'actions-template', serverField: 'ContactName'  },
			],
			result: null,
			xmlRequestTextVisible: false,
			processingItems: [],
			isUploading: false,
			mappingLicenseRequestId: null,
			adServerDownloadLink: null,
			requestStates: ['Initial', 'Pending', 'Approved', 'Denied', 'Invalidated']
		};
	},
	computed: {
		items() {
			return this.result && this.result.Results.map(f => ({
				...f,
				ContactName: f.Contact && f.Contact.Title,
				StateName: this.requestStates[f.State + 1]
			}));
		}
	},
	mounted() {
		this.loadAdServerDownloadLink();
	},
	methods: {
		loadAdServerDownloadLink() {
			this.$Data.getExternalApi('Service/GetAdServerDownloadLink').then(r => {
				if (r) {
					this.adServerDownloadLink = r;
				}
			})
		},
		setMappingLicenseRequestId(v) {
			this.mappingLicenseRequestId = null;
			if (v)
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.mappingLicenseRequestId = v;
				})
		},
		approve(licenseRequestId, state) {
			this.$confirmMessage({
				title: () => this.$tCaption('Confirm action', '@actions'),
				text: () => `${this.$tCaption('Are you sure you want to')} ${state === 1 ? this.$tCaption('approve & sign') : this.$tCaption('deny')} ${this.$tCaption('license request')}?`,
				handler: () => {
					this.processingItems.push(licenseRequestId);
					this.$Data.getExternalApi('Company/SetLicenseRequestState', `licenseRequestId=${licenseRequestId}&state=${state}`).then(r => {
						if (r.Success) {
							this.$notifySuccess(this.$tCaption('Request state has been updated'));
							this.$refs.listView.reload();
						} else {
							this.$notifyError(r.ErrorMessage);
						}
					}).finally(() => this.processingItems.splice(this.processingItems.indexOf(licenseRequestId), 1));
				}
			});
		},
		onFileUpload(v) {
			var fr = new FileReader;
			fr.readAsText(v[0]);
			fr.onloadend = () => {
				var data = fr.result;
				if (__DEBUG__)
					console.info('Upload request', { data });

				this.isUploading = true;
				this.$Data.postExternalApi('Company/CreateUpdateLicenseRequest', {
					RequestXML: data,
					Company: {
						Oid: this.$auth.companyId()
					}
				}).then(r => {
					if (r.Success) {
						this.$notifySuccess(this.$tCaption('Request has been successfully created'));
						this.$refs.listView.reload();
						this.setMappingLicenseRequestId(r.Data.Oid);
					} else {
						this.$notifyError(r.ErrorMessage);
					}
				})
				.catch(ex => this.$notifyError(ex))
				.finally(() => this.isUploading = false);
			};
		},
		loadData(pageIndex, size, sortings) {
			return Data.getLicenseRequests(pageIndex, size, sortings).then(r => {
				if (__DEBUG__)
					console.debug('License requests loaded', { r });
				this.result = r;
				return r;
			});
		},
		addNewRow(){
			this.$refs.uploader.showPopup();
		},
		getLicenseLink(data) {
			return this.$Data.getMethodUrl(`externalApi?accessToken=${this.$auth.accessToken()}&method=Company/DownloadLicense&parameters=licenseRequestId=${data.Oid}`);
		},
		onLicenseRequestsClose() {
			this.mappingLicenseRequestId = null;
			this.$refs.listView.reload();
		},
		revoke(licenseRequestId) {
			this.$confirmMessage({
				title: () => this.$tCaption('Confirm action', '@actions'),
				text: this.$tCaption('Are you sure you want to revoke license request?'),
				handler: () => {
					this.processingItems.push(licenseRequestId);
					this.$Data.getExternalApi('Company/RevokeLicenseFromApprove', `licenseRequestId=${licenseRequestId}`).then(r => {
						if (r.Success) {
							this.$notifySuccess(this.$tCaption('Request has been revoked'));
							this.$refs.listView.reload();
						} else {
							this.$notifyError(r.ErrorMessage);
						}
					}).finally(() => this.processingItems.splice(this.processingItems.indexOf(licenseRequestId), 1));
				}
			});
		}
	}
};
</script>
<style lang="scss">
	.license-requests-list {
		position: relative;

		.license-link {
			padding: 5px;
			text-decoration: none;
		}

		.xml-text {
			max-width: 300px;
			cursor: pointer;
			white-space: pre-wrap;

			&.collapsed {
				max-width: 200px;
				overflow: hidden;
				text-overflow: ellipsis;
				max-height: 30px;
				white-space: nowrap;
			}
		}

		.state-text {
			background: #eeeeee;
			padding: 4px;
			border-radius: 4px;
			text-transform: uppercase;
			font-size: 12px;

			&.approved {
				background: #85f4a9;
			}

			&.denied, &.invalidated {
				background: #f48585;
			}

			&.pending {
				background: #f4ffc1;
			}

			&.initial {
				background: #f8f8f8;
			}
		}

		.download-ad-server-link {
			padding: 4px 10px;
			text-decoration: none;
			color: #333;

			&:hover {
				background: #ebebeb;
			}
		}
	}
</style>
